import { Component, OnInit } from '@angular/core';
import { IdealsOneApiService } from '../services/ideals-one-api.service';
import { strictEqual } from 'assert';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { JsonPipe } from '@angular/common';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  public getResponseData: any;
  footerData: any;
  city: any;
  address: any;
  postal_code: any;
  state: any;
  items: [];
  font_color: any;

  pageInfoDataForFooterObj: any;
  pageInfoDataForFooter: any;

  constructor(private idealsOneApiService: IdealsOneApiService) { }

  ngOnInit() {
    // this.getFooterData();
    this.pageInfoData();
  }

    pageInfoData() {
      const pageFooterData = () => {
        this.pageInfoDataForFooter = sessionStorage.getItem('pageinformationData');
      };
      const pageInfoTimer = setTimeout(pageFooterData, 30000);
      if (sessionStorage.getItem('pageinformationData')) {
        // alert(sessionStorage.getItem("pageinformationData"));
        this.pageInfoDataForFooter = sessionStorage.getItem('pageinformationData');
        this.pageInfoDataForFooterObj = JSON.parse(this.pageInfoDataForFooter);

        this.footerData = this.pageInfoDataForFooterObj.data.footer;
        this.city = this.footerData.address.city;
        this.address = this.footerData.address.addr;
        this.postal_code = this.footerData.address.postal_code;
        this.state = this.footerData.address.state;
        this.items = this.footerData.address.items;
        clearTimeout(pageInfoTimer);
      } else {
        pageFooterData();
      }
    }
}
